export default function directCheckoutAsset(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.map((assetData, index) => {
        const assetCode = assetData.asset;
        let row = [];
        const rowId = `${config.tableType}|${assetCode}`;

        config.columns.forEach(column => {
            const columnId = column.id;
            let columnDataType = column.data.displayInBodyAs;
            const displayAsIs = column.data.displayInBodyAsIs;
            const highlightColumn = column.data.highlightBodyText;

            let columnValue = 0;
            let columnValueData = null;
            let columnLabelValue = null;
            let isDisabled = false;


            //Last element in the list represents "Total" which should be disabled
            if (config.data.length - index === 1) {
                columnValue = assetData[columnId];
                isDisabled = true;
                columnDataType = "string";
            }
            else if (columnDataType === "input") {
                columnValueData = { defaultValue: assetData[columnId] || "", ...column.data };
            } else {
                columnValue = assetData[columnId];
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    label: columnLabelValue,
                    width: column.width,
                    disabled: isDisabled,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, assetCode) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });

    result['columns'] = config.columns;
    result['data'] = tableData;
    return result;
}